import Organisations from './pages/Organisations';

export default Organisations;
